module.exports = __webpack_public_path__ + "img/sim_itel.373f8738.png";